import { FC } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Colors, FInter, FlexBox, GridBox, repeat, useScale } from '@brg/ui';
import { AppNodeMode, MiniApplicationManifest } from 'core/helpers/dna';
import { greyTheme } from '../../themes/greyTheme';
import { PageViewportLayout } from '../../components/template';
import { TeamImg, TeamPageViewportLayout } from './styles';
import alexencom from './imgs/alexencom.jpeg';
import ev1lm0us3 from './imgs/ev1lm0us3.jpeg';
import dorothieny from './imgs/dorothieny.jpg';
import alyaskana from './imgs/alyaskana.jpg';
import ztlsz from './imgs/ztlsz.jpg';
import yopur from './imgs/yopur.jpeg';
import mairrin from './imgs/mairrin.jpeg';
import warmekat from './imgs/warmekat.jpg';

const manifest: MiniApplicationManifest = {
    // Название мини-приложения - и document.title
    title: 'Team',

    // объект редукторов (redux)
    reducer: {},
    // @ts-ignore
    theme: greyTheme,

    // авторизация
    auth: {
        productionClientId: '',
        developClientId: '',
    },
};

/**
 * Приложение. Это точка входа. Все начинается отсюда.
 * Провайдеры, оформление страницы - да все, что угодно!
 *
 * Любое свершение начинается с точки входа - удачного кодинга :)
 *
 * Переменная `mode` может принимать 3 значения: 'develop', 'staging' и 'production'
 */
const App: FC<{ mode: AppNodeMode }> = () => (
    // @ts-ignore
    <BrowserRouter>
        <Routes />
    </BrowserRouter>
);

/**
 * Компонент роутера - обязательная часть ядра Geograffee
 *
 * Отсюда маршрутизация по мини-приложению
 */
const Routes: FC = () => {
    return (
        <Switch>
            <Route path={'/'} component={Example} />
        </Switch>
    );
};

export const ItemComponent: FC<{ name: string; lastname: string; image: string; nick: string }> = (props) => (
  <FlexBox direction={'column'} style={{ textAlign: 'center' }}>
      <TeamImg src={props.image} />
      <FInter.TextBoldFlex justify={'center'} offsetTop={8} color={Colors.geoWhite73}>
          {props.lastname}
      </FInter.TextBoldFlex>
      <FInter.TextDiv color={Colors.geoWhite73}>{props.name}</FInter.TextDiv>
      <FInter.TextDiv color={Colors.geoWhite47}>{props.nick}</FInter.TextDiv>
  </FlexBox>
);

/**
 * Компонент для примера работы маршрутизатора
 */
const Example: FC = () => {
    const s = useScale();

    const content = [
        {
            title: 'Дизайнеры',
            description: 'Макеты и пользовательский опыт',
            items: [
                { name: 'Кирилл', lastname: 'Романов', nick: '@yopur', image: yopur },
                { name: 'Ирина', lastname: '', nick: '@mairrin', image: mairrin },
                { name: 'Наталья', lastname: 'Шестакова', nick: '@mairrin', image: '' },
                { name: 'Алена', lastname: 'Романова', nick: '@yopur', image: '' },
                { name: 'Анатолий', lastname: 'Гращенко', nick: '@grshch', image: '' },
            ],
        },
        {
            title: 'Front-end разработчики',
            description: 'Реализация макетов и функциональная часть',
            items: [
                {
                    name: 'Павел',
                    lastname: 'Потапов',
                    nick: '@ztlsz',
                    image: ztlsz,
                },
                {
                    name: 'Яков',
                    lastname: 'Панов',
                    nick: '@notafoks',
                    image: 'https://sun9-20.userapi.com/impg/e3x7jPesniw6b2yLvzaYT6unUhQbZemrhLnk5g/5Ptx0ER4kG4.jpg?size=960x960&quality=95&sign=d74da2ebee994bbe3343b7e699c2556c&type=album',
                },
                {
                    name: 'Владимир',
                    lastname: 'Кустов',
                    nick: '@warmekat',
                    image: warmekat,
                },
                {
                    name: 'Николай',
                    lastname: 'Кравцов',
                    nick: '@nick.kravtsov',
                    image: '',
                },
                {
                    name: 'Алина',
                    lastname: '',
                    nick: '@alyaskana',
                    image: alyaskana,
                },
                {
                    name: 'Дарья',
                    lastname: 'Пономарева',
                    nick: '@dorothieny',
                    image: dorothieny,
                },
            ],
        },
        {
            title: 'Back-end разработчики',
            description: 'Базы данных и взаимодействие с ними',
            items: [
                {
                    name: 'Александр',
                    lastname: 'Попов',
                    nick: '@alexencom',
                    image: alexencom,
                },
                {
                    name: 'Нурсултан',
                    lastname: '',
                    nick: '@niki_twix',
                    image: '',
                },
                {
                    name: 'Геннадий',
                    lastname: '',
                    nick: '@ev1lm0us3',
                    image: ev1lm0us3,
                },
                {
                    name: 'Алена',
                    lastname: 'Солдатова',
                    nick: '',
                    image: '',
                },
                {
                    name: 'Алексей',
                    lastname: 'Павлов',
                    nick: '',
                    image: '',
                },
            ],
        },
        {
            title: 'Системные администраторы',
            description: 'Серверные машины, среда для работы проектов',
            items: [
                {
                    name: 'Артур',
                    lastname: '',
                    nick: '@dmin_pro',
                    image: '',
                },
            ],
        },
    ];

    return (
        <TeamPageViewportLayout>
            <FInter.SectionTitleSubtitleFlex
                align={'center'}
                justify={'center'}
                height={80}
                color={Colors.brickRedFailedGal}
            >
                Страница пока еще в разработке
            </FInter.SectionTitleSubtitleFlex>
            {content.map((value, i) => (
                <PageViewportLayout key={i}>
                    <FInter.MainTitleSmallDiv color={Colors.geoWhite100}>{value.title}</FInter.MainTitleSmallDiv>
                    <FInter.Text color={Colors.geoWhite47}>{value.description}</FInter.Text>
                    <FlexBox width={s(1152)} offsetTop={16}>
                        <GridBox gap={16} cols={repeat(4, '1fr')}>
                            {value.items.map((item, j) => (
                                <ItemComponent {...item} key={j} />
                            ))}
                        </GridBox>
                    </FlexBox>
                </PageViewportLayout>
            ))}
        </TeamPageViewportLayout>
    );
};

const app = { App, manifest };

// Это обязательная часть. Она очень важна!
export default app;
import { FC } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Colors, FInter, FlexBox, GridBox, repeat, useScale } from '@brg/ui';
import { AppNodeMode, MiniApplicationManifest } from 'core/helpers/dna';
import { greyTheme } from '../../themes/greyTheme';
import { PageViewportLayout } from '../../components/template';
import { TeamImg, TeamPageViewportLayout } from './styles';
import alexencom from './imgs/alexencom.jpeg';
import ev1lm0us3 from './imgs/ev1lm0us3.jpeg';
import dorothieny from './imgs/dorothieny.jpg';
import alyaskana from './imgs/alyaskana.jpg';
import ztlsz from './imgs/ztlsz.jpg';
import yopur from './imgs/yopur.jpeg';
import mairrin from './imgs/mairrin.jpeg';
import warmekat from './imgs/warmekat.jpg';

const manifest: MiniApplicationManifest = {
    // Название мини-приложения - и document.title
    title: 'Team',

    // объект редукторов (redux)
    reducer: {},
    // @ts-ignore
    theme: greyTheme,

    // авторизация
    auth: {
        productionClientId: '',
        developClientId: '',
    },
};

/**
 * Приложение. Это точка входа. Все начинается отсюда.
 * Провайдеры, оформление страницы - да все, что угодно!
 *
 * Любое свершение начинается с точки входа - удачного кодинга :)
 *
 * Переменная `mode` может принимать 3 значения: 'develop', 'staging' и 'production'
 */
const App: FC<{ mode: AppNodeMode }> = () => (
    // @ts-ignore
    <BrowserRouter>
        <Routes />
    </BrowserRouter>
);

/**
 * Компонент роутера - обязательная часть ядра Geograffee
 *
 * Отсюда маршрутизация по мини-приложению
 */
const Routes: FC = () => {
    return (
        <Switch>
            <Route path={'/'} component={Example} />
        </Switch>
    );
};

export const ItemComponent: FC<{ name: string; lastname: string; image: string; nick: string }> = (props) => (
  <FlexBox direction={'column'} style={{ textAlign: 'center' }}>
      <TeamImg src={props.image} />
      <FInter.TextBoldFlex justify={'center'} offsetTop={8} color={Colors.geoWhite73}>
          {props.lastname}
      </FInter.TextBoldFlex>
      <FInter.TextDiv color={Colors.geoWhite73}>{props.name}</FInter.TextDiv>
      <FInter.TextDiv color={Colors.geoWhite47}>{props.nick}</FInter.TextDiv>
  </FlexBox>
);

/**
 * Компонент для примера работы маршрутизатора
 */
const Example: FC = () => {
    const s = useScale();

    const content = [
        {
            title: 'Дизайнеры',
            description: 'Макеты и пользовательский опыт',
            items: [
                { name: 'Кирилл', lastname: 'Романов', nick: '@yopur', image: yopur },
                { name: 'Ирина', lastname: '', nick: '@mairrin', image: mairrin },
                { name: 'Наталья', lastname: 'Шестакова', nick: '@mairrin', image: '' },
                { name: 'Алена', lastname: 'Романова', nick: '@yopur', image: '' },
                { name: 'Анатолий', lastname: 'Гращенко', nick: '@grshch', image: '' },
            ],
        },
        {
            title: 'Front-end разработчики',
            description: 'Реализация макетов и функциональная часть',
            items: [
                {
                    name: 'Павел',
                    lastname: 'Потапов',
                    nick: '@ztlsz',
                    image: ztlsz,
                },
                {
                    name: 'Яков',
                    lastname: 'Панов',
                    nick: '@notafoks',
                    image: 'https://sun9-20.userapi.com/impg/e3x7jPesniw6b2yLvzaYT6unUhQbZemrhLnk5g/5Ptx0ER4kG4.jpg?size=960x960&quality=95&sign=d74da2ebee994bbe3343b7e699c2556c&type=album',
                },
                {
                    name: 'Владимир',
                    lastname: 'Кустов',
                    nick: '@warmekat',
                    image: warmekat,
                },
                {
                    name: 'Николай',
                    lastname: 'Кравцов',
                    nick: '@nick.kravtsov',
                    image: '',
                },
                {
                    name: 'Алина',
                    lastname: '',
                    nick: '@alyaskana',
                    image: alyaskana,
                },
                {
                    name: 'Дарья',
                    lastname: 'Пономарева',
                    nick: '@dorothieny',
                    image: dorothieny,
                },
            ],
        },
        {
            title: 'Back-end разработчики',
            description: 'Базы данных и взаимодействие с ними',
            items: [
                {
                    name: 'Александр',
                    lastname: 'Попов',
                    nick: '@alexencom',
                    image: alexencom,
                },
                {
                    name: 'Нурсултан',
                    lastname: '',
                    nick: '@niki_twix',
                    image: '',
                },
                {
                    name: 'Геннадий',
                    lastname: '',
                    nick: '@ev1lm0us3',
                    image: ev1lm0us3,
                },
                {
                    name: 'Алена',
                    lastname: 'Солдатова',
                    nick: '',
                    image: '',
                },
                {
                    name: 'Алексей',
                    lastname: 'Павлов',
                    nick: '',
                    image: '',
                },
            ],
        },
        {
            title: 'Системные администраторы',
            description: 'Серверные машины, среда для работы проектов',
            items: [
                {
                    name: 'Артур',
                    lastname: '',
                    nick: '@dmin_pro',
                    image: '',
                },
            ],
        },
    ];

    return (
        <TeamPageViewportLayout>
            <FInter.SectionTitleSubtitleFlex
                align={'center'}
                justify={'center'}
                height={80}
                color={Colors.brickRedFailedGal}
            >
                Страница пока еще в разработке
            </FInter.SectionTitleSubtitleFlex>
            {content.map((value, i) => (
                <PageViewportLayout key={i}>
                    <FInter.MainTitleSmallDiv color={Colors.geoWhite100}>{value.title}</FInter.MainTitleSmallDiv>
                    <FInter.Text color={Colors.geoWhite47}>{value.description}</FInter.Text>
                    <FlexBox width={s(1152)} offsetTop={16}>
                        <GridBox gap={16} cols={repeat(4, '1fr')}>
                            {value.items.map((item, j) => (
                                <ItemComponent {...item} key={j} />
                            ))}
                        </GridBox>
                    </FlexBox>
                </PageViewportLayout>
            ))}
        </TeamPageViewportLayout>
    );
};

const app = { App, manifest };

// Это обязательная часть. Она очень важна!
export default app;
